// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"63a706c2","236":"c271246a","299":"d787a589","453":"c2b2afdb","916":"ccf313d3"}[chunkId] + ".chunk.js";
};